module.exports = __webpack_public_path__ + "r-v3/img/ml_11_01_over.694370b4.jpg";